// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import Iconify from "../../../components/Iconify";
import { useTranslation } from "react-i18next";
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <Iconify icon={name} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  topup: getIcon("solar:smartphone-2-bold-duotone"),
  moncash: getIcon("solar:card-transfer-bold-duotone"),
  natcash: getIcon("solar:wallet-money-bold-duotone"),
  transfer: getIcon("solar:transfer-horizontal-bold-duotone"),
  dashboard: getIcon("solar:widget-5-bold-duotone"),
  agent: getIcon("solar:users-group-rounded-bold-duotone"),
  user: getIcon("solar:settings-bold-duotone"),
  ticket: getIcon("solar:ticket-bold-duotone"),
  report: getIcon("solar:chart-square-bold-duotone"),
};

const NavConfig = () => {
  const { t } = useTranslation();
  const navConfig = [
    {
      subheader: t("sideBar.OVERVIEW"),
      items: [
        {
          title: t("sideBar.OVERVIEW"),
          path: PATH_DASHBOARD.general.app,
          icon: ICONS.dashboard,
        },
      ],
    },
    {
      subheader: t("sideBar.TRANSACTIONS"),
      items: [
        {
          title: t("sideBar.vendor"),
          path: PATH_DASHBOARD.agent.root,
          icon: ICONS.agent,
          children: [
            { title: t("sideBar.add_vendor"), path: PATH_DASHBOARD.agent.add },
            { title: t("sideBar.list_vendor"), path: PATH_DASHBOARD.agent.list },
          ],
        },
        {
          title: t("p_sendtopup.sendtopup"),
          path: PATH_DASHBOARD.sendtopup.root,
          icon: ICONS.topup,
        },
        {
          title: t("p_sendmoncash.sendmoncash"),
          path: PATH_DASHBOARD.sendmoncash.root,
          icon: ICONS.moncash,
        },
        {
          title: t("p_sendnatcash.sendnatcash"),
          path: PATH_DASHBOARD.sendnatcash.root,
          icon: ICONS.natcash,
        },
        {
          title: t("p_sendtransfer.sendtransfer"),
          path: PATH_DASHBOARD.sendtransfer.root,
          icon: ICONS.transfer,
        },
        {
          title: t("sideBar.ticket_sale"),
          path: PATH_DASHBOARD.ticket.sale,
          icon: ICONS.ticket,
        },
        {
          title: t("sideBar.report_sale"),
          path: PATH_DASHBOARD.report.sale,
          icon: ICONS.report,
        },
        {
          title: t("params.all_transaction"),
          path: PATH_DASHBOARD.report.transactions,
          icon: ICONS.ticket,
        },
      ],
    },
    {
      subheader: "Paramettre",
      items: [
        {
          title: t("sideBar.user"),
          path: PATH_DASHBOARD.user.account,
          icon: ICONS.user,
        },
      ],
    },
  ];
  return navConfig;
};

export default NavConfig;
